export enum Sizes {
  INHERIT = 'inherit',
  XSMALL = 'xsmall',
  SMALL = 'small',
  XMEDIUM = 'xmedium',
  MEDIUM = 'medium',
  LARGE = 'large',
  XLARGE = 'xlarge',
  XXLARGE = 'xxlarge',
  XXXLARGE = 'xxxlarge',
}
export enum Colors {
  WHITE = '#fff',
  BLACK = '#000',
  BLACK_LIGHT = '#3b3c3c',
  GREEN = '#65a518',
  GREEN_LIGHT = '#c1dba3',
  GREEN_SUCCESS = '#e0edd1',
  GREEN_LOGO = '#006729',
  TURQUOISE = '#008080',
  BLUE = '#003960',
  LIGHT_BLUE = '#00a3a8',
  NEUTRAL_DARK = '#282828',
  NEUTRAL_MEDIUM = '#6c6f70',
  NEUTRAL_LIGHTEST = '#f9f9fa',
  NEUTRAL_LIGHTER = '#eeeeef',
  GREY = '#6C6F70',
  LILLA = '#E20AD1',
  ERROR = '#E60018',
}

export enum Headlines {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  H5 = 'h5',
  H6 = 'h6',
}
